<template>
  <div>
    <private-layer>
      <template slot="box-title">
        <div class="title">报警</div>
      </template>
      <template slot="box-inner">
        <div class="content">
          <div class="list clearfix" v-scrollBar>
            <div class="cell" v-for="item in options">
              <div class="text">
                <div class="label">{{item.alarm_type}}</div>
                <div class="value">{{item.address}}</div>
              </div>
              <div v-if="item.status == 2">
                <div class="btn" @click="confirmClick(item.id)">已确认</div>
                <div class="btn2" @click="neglectClick(item.id)">忽略</div>
              </div>
            </div>
          </div>
          <div class="tips">
            <span><a href="/alarm" class="more">更多</a></span>
          </div>
        </div>
      </template>
    </private-layer>
  </div>
</template>

<script>
import PrivateLayer from '../layer'
import { GetAlarmList } from '@/api/home'
import { UpdateStatus } from '@/api/alarm'
import { MessageBox } from 'element-ui'
export default {
  components: { PrivateLayer },
  data(){
    return{
      options: []
    }
  },
  created(){
    this.initAlarmList();
  },
  methods: {
    initAlarmList(){
      GetAlarmList().then(res => {
        this.options = res.alarmList
      })
    },
    //忽略
    neglectClick(id) {
      const data = {
        id: id,
        status: 0
      }
      MessageBox.confirm('确认忽略?', '提示', {
        confirmButtonText: '确定',
        concelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        UpdateStatus(data).then(res => {
          if(res.code == 0) {
            this.$message.success("操作成功")
            this.initAlarmList()
          }
        })
      }).catch(() => {})
    },
    //已确认
    confirmClick(id) {
      const data = {
        id: id,
        status: 1
      }
      MessageBox.confirm('确认?', '提示', {
        confirmButtonText: '确定',
        concelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        UpdateStatus(data).then(res => {
          if(res.code == 0) {
            this.$message.success("操作成功")
            this.initAlarmList()
          }
        })
      }).catch(() => {})
    },
  }
}
</script>

<style lang="less" scoped>
.content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 0px 0px 12px;
  color: #fff;
  .list {
    position: relative;
    flex: 1;
    min-height: 0;
    .cell {
      position: relative;
      padding-right: 120px;
      & + .cell {
        margin-top: 10px;
      }
      .text {
        .label {}
        .value {
          color: #70757e;
          padding-top: 4px;
        }
      }
      .btn {
        position: absolute;
        right: 0;
        top: 4px;
        width: 56px;
        text-align: center;
        border-radius: 4px;
        background: #142542;
        color: #fff;
        line-height: 26px;
        cursor: pointer;
      }
      .btn2 {
        position: absolute;
        right: 60px;
        top: 4px;
        width: 45px;
        text-align: center;
        border-radius: 4px;
        background: #142542;
        color: #fff;
        line-height: 26px;
        cursor: pointer;
      }
    }
  }
  .tips {
    text-align: right;
    line-height: 2em;
    color: #00a2f6;
    margin-top: 20px;
    padding-right: 5px;
  }
  .more {
    color: #00a2f6;
  }
}
</style>
